export class EndGameStateUtils {
    static getPlayersSortedByRank(players) {
        const playersArray = Object.values(players);
        playersArray.sort((a, b)=>a.rank - b.rank);
        return playersArray;
    }
}
